const currentlyWorkingStatuses = [
  {
    name: "Yes, I found a job",
    value: "FOUND_JOB",
  },
  {
    name: "Yes, but I am looking for a better job",
    value: "FOUND_JOB_LOOKING_FOR_BETTER",
  },
  {
    name: "No, I am looking for a job",
    value: "NO_BUT_LOOKING",
  },
  {
    name: "No, I am not looking for a job",
    value: "NO_NOT_LOOKING",
  },
  {
    name: "Could not be contacted",
    value: "UNABLE_TO_CONTACT",
  },
];

export default currentlyWorkingStatuses;
